/**
 * Constants for RIV API method names used in metrics tracking
 */
export enum RIVApiMethods {
    INIT = 'Init',
    GET_CONTAINER = 'GetContainer',
    BATCH_MOVE_CONTAINERS = 'BatchMoveContainers',
    CLOSE_CONTAINER = 'CloseContainer',
    RECEIVE_CONTAINER = 'ReceiveContainer',
    PRINT_CONTAINER_LABEL = 'PrintContainerLabel',
    PROCESS_CONTAINER = 'ProcessContainer',
    GET_SORT_TYPES = 'GetSortTypes',
    SET_ROUTING_DESTINATION = 'SetRoutingDestination',
    CLEAN_A_DIRTY_TOTE = 'CleanADirtyTote',
    CREATE_CONTAINER = 'CreateContainer'
}
